import { IDefineCommand, IQuery } from 'core-ts-types';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { UpdateSelectedSectionStatusCommand } from './update_selected_section_status_command';
import { ISectionsDatasource } from '../../../views/sections/datasources/sections_datasource';
import { CrossCourseLinkedSectionServant } from '../../../views/course_scheduler/servants/cross_course_linked_section_servant';
import { ScheduledSectionsQuery } from '../../../views/course_scheduler/queries/scheduled_sections_query';

export type UpdateSelectedLinkedSectionStatusCommand = (
  selectedSectionIds: ISection['id'],
  isSelected: boolean
) => ng.IPromise<IQuery[]>;

/**
 * Decide whether to include linked sections in the registration selection
 */
angular
  .module('capability-ng-scheduler')
  .service(
    'updateSelectedLinkedSectionStatusCommand',
    function updateSelectedLinkedSectionStatusCommand(
      defineCommandORM: IDefineCommand,
      $q: ng.IQService,
      ngSectionsDatasource: ISectionsDatasource,
      ngCrossCourseLinkedSectionServant: CrossCourseLinkedSectionServant,
      ngScheduledSectionsQuery: ScheduledSectionsQuery,
      updateSelectedSectionStatusCommand: UpdateSelectedSectionStatusCommand
    ) {
      'use strict';

      return defineCommandORM(
        'updateSelectedLinkedSectionStatusCommand',
        (deferred, selectedSectionId: ISection['id'], isSelected: boolean) => {
          const section = ngSectionsDatasource.get(selectedSectionId);
          if (!section) {
            deferred.resolve();
            return;
          }
          const hasLinkedSections = !_4.isEmpty(_4.get(section, '_linked_sections', []));
          if (!hasLinkedSections) {
            updateSelectedSectionStatusCommand(section, isSelected);
          }
          const crossCourseLinkedSectionIds = ngCrossCourseLinkedSectionServant.getSectionIdOfLinkedCrossCourses(
            section.id,
            ngScheduledSectionsQuery.result.list
          );
          // Include itself as well as coreqs
          crossCourseLinkedSectionIds.push(section.id);
          const crossCourseLinkedSections = ngScheduledSectionsQuery.result.list.filter((section) =>
            crossCourseLinkedSectionIds.includes(section.id)
          );
          const updateLinkedSectionsStatusPromises = crossCourseLinkedSections.map((section) =>
            updateSelectedSectionStatusCommand(section, isSelected)
          );
          $q.all(updateLinkedSectionsStatusPromises).then(deferred.resolve);
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_selections/commands/update_selected_linked_section_status_command.ts